var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 379,
    height: 393,
    viewBox: "0 0 379 393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1712",
    "data-name": "Grupo 1712",
    transform: "translate(-793.5 -288.61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2231",
    "data-name": "Ret\\xE2ngulo 2231",
    width: 379,
    height: 393,
    transform: "translate(793.5 288.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "image-o",
    d: "M236.661,0a28.782,28.782,0,0,1,21.165,8.676A28.836,28.836,0,0,1,266.5,29.841v206.82A29.625,29.625,0,0,1,236.661,266.5H29.841a28.782,28.782,0,0,1-21.165-8.676A28.836,28.836,0,0,1,0,236.661V29.841A28.782,28.782,0,0,1,8.676,8.676,28.836,28.836,0,0,1,29.841,0Zm0,236.661V29.841H29.841v206.82ZM162.4,137.419l52.049,70.1H52.049l40.257-52.745,29.152,35.393Z",
    transform: "translate(849.409 351.579)",
    fill: "#d3d3d3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefault);
export default __webpack_public_path__ + "static/media/image-default.73ecf5f253b67c74efb2d55210e6ef8a.svg";
export { ForwardRef as ReactComponent };